import "@babel/polyfill";

import { io } from "socket.io-client";

console.log("V0.0.10");

// const API_URL = "http://localhost:3500";
// const QUEUE_URL = "https://queue.afilaanda.co";

const environments = {
  local: {
    API_URL: "http://localhost:3500",
    QUEUE_URL: "http://localhost:3001",
    ANALYTICS_URL: "http://localhost:3003",
  },
  development: {
    API_URL: "https://api-dev.afilaanda.co",
    QUEUE_URL: "https://queue-dev.afilaanda.co",
    ANALYTICS_URL: "https://analytics.afilaanda.co",
  },
  production: {
    API_URL: "https://api.afilaanda.co",
    QUEUE_URL: "https://queue.afilaanda.co",
    ANALYTICS_URL: "https://analytics.afilaanda.co",
  },
};

import qs from "qs";
import axios from "axios";
import { maxSessionTime } from "./maxSessionTime";

axios.defaults.withCredentials = true;

export function analytics(ANALYTICS_URL, sessionId) {
  try {
    console.log('CALLING ANALYTICS', sessionId);
    const loop = async () => {
      try {
        const requestOptions = {
          method: "POST",
          redirect: "follow",
        };

        await fetch(`${ANALYTICS_URL}/analytics/${sessionId}`, requestOptions);
      } catch (err) {
        console.error(err);
      }
      setTimeout(loop, 5000);
    };

    loop();
  } catch {}
}


async function exec() {
  const sessionId = window?.A_FILA_ANDA?.sessionId;
  const environment = window?.A_FILA_ANDA?.environment;

  const { API_URL, QUEUE_URL, ANALYTICS_URL } =
    environments[environment] || environments.production;

  if (!sessionId) {
    throw new Error("SESSION_ID_INVALID");
  }

  const { accessTokenQueue } = qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
  });

  if (sessionId === '6571ae0ba6820600087ae387') {
    // if location is / || input name="eventoId" continue else return
    if (window.location.pathname === '/' || document.querySelector('input[name="eventoId"]')) {
      // continue
    } else {
      return;
    }
  }

  const accessToken =
    accessTokenQueue ||
    window.localStorage.getItem(`${sessionId}-access-token`);

  if (accessToken) {
    window.localStorage.setItem(`${sessionId}-access-token`, accessToken);
    setTimeout(() => {
      window.localStorage.setItem(`${sessionId}-access-token`, accessToken);
    }, 1000)

  }

  const { data: sessionInfo } = await axios.get(
    `${API_URL}/queue/${sessionId}`
  );

  if (
    sessionInfo.status !== "inactive" &&
    sessionInfo.organization.lockedUrl &&
    window.location.href
      .replace("http://", "")
      .replace("https://", "")
      .includes(
        sessionInfo.organization.lockedUrl
          .replace("http://", "")
          .replace("https://", "")
      )
  ) {
    if (!accessToken) {
      // inject a html with "Não redirecionado? Clique aqui" and a button to redirect full page zIndex 9999
      const div = document.createElement("div");
      div.style.position = "fixed";
      div.style.display = "flex";
      div.style.justifyContent = "center";
      div.style.alignItems = "center";
      div.style.top = "0";
      div.style.left = "0";
      div.style.width = "100%";
      div.style.height = "100%";
      div.style.backgroundColor = "rgba(0, 0, 0, 0.8)";
      div.style.zIndex = "9999";

      const button = document.createElement("button");

      button.style.padding = "10px 20px";
      button.style.backgroundColor = "#000";
      button.style.color = "#fff";
      button.style.border = "1px solid #fff";
      button.style.cursor = "pointer";
      button.style.borderRadius = "5px";
      button.style.fontSize = "16px";

      button.textContent = "Não redirecionado? Clique aqui";

      try {
        // hide everything but this new div
        const all = document.body.children;

        for (let i = 0; i < all.length; i++) {
          all[i].style.display = "none";
        }
      } catch (err) {
        console.log('ERR', err);
      }

      button.onclick = () => {
        window.location.href = `${QUEUE_URL}/${sessionId}?url=${encodeURIComponent(window.location.href)}`;
      };

      div.appendChild(button);

      document.body.appendChild(div);

      window.location.href = `${QUEUE_URL}/${sessionId}?url=${encodeURIComponent(window.location.href)}`;
    }

    try {
      await axios.get(`${API_URL}/queue/${sessionId}/check`, {
        params: { accessToken },
      });
      try {
        maxSessionTime(sessionInfo.organization.paymentMethod, accessToken, QUEUE_URL, sessionId)
      } catch (err) {
        console.log('ERR', err);
      }

      analytics(ANALYTICS_URL, sessionId);
    } catch {
      window.location.href = `${QUEUE_URL}/${sessionId}?url=${encodeURIComponent(
        window.location.href
      )}`;
    }
  }
}

exec();
